import { render, staticRenderFns } from "./FintechCategories.vue?vue&type=template&id=1f16fc4b&"
import script from "./FintechCategories.vue?vue&type=script&lang=js&"
export * from "./FintechCategories.vue?vue&type=script&lang=js&"
import style0 from "./FintechCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports